module.exports = __webpack_public_path__ + "img/orange_112.8e71a9ff.png";